export default "__VITE_ASSET__BzPKWDmX__"